import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '../store';

export function useTheme() {
  const { mode, setTheme } = useStore(
    useShallow((state) => ({
      mode: state.theme.mode,
      setTheme: state.theme.setTheme,
    })),
  );

  useEffect(() => {
    const root = document.documentElement;

    if (mode === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      const apply = () => {
        root.classList.toggle('dark', mq.matches);
      };
      apply();
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }

    root.classList.toggle('dark', mode === 'dark');
  }, [mode]);

  return { mode, setTheme };
}
